import React from 'react';
// import {  } from 'actions/auth';
import { IRootState } from 'store';
import { IScholarsState, IUserState } from 'types';
import { connect } from 'react-redux';
import ChangeEmail from './changeEmail';
import ChangePassword from './changePassword';
import CloseAccount from './deleteAccount';
import styles from './index.module.scss';

const mapStateToProps = (state: IRootState) => ({
  user: state.users,
});
interface IProps {
  scholars?: IScholarsState;
  user?: IUserState;
}

const AccountSettings: React.FC<IProps> = ({ user }) => {
  return (
    <>
      <div className={styles.accountSettings}>
        <ChangeEmail
          error={user?.errors || []}
          currentEmail={user?.userData?.email || ''}
        />
        <ChangePassword />
        <CloseAccount />
      </div>
    </>
  );
};
export default connect(mapStateToProps)(AccountSettings);
